
import { Card } from './types';

/** La Clica's swarm token. Summoned by tribe breakpoints and card abilities. */
export const MORRITO_TOKEN_ID = 'token_morrito';

/**
 * Token cards - summoned by abilities, not available in shop.
 */
export const tokens: Card[] = [
  {
    "id": "token_kitten",
    "name": "Michi del Callejón",
    "faction": "neutral",
    "tier": 1,
    "attack": 1,
    "health": 1,
    "text": "",
    "tags": ["token"]
  },
  {
    "id": MORRITO_TOKEN_ID,
    "name": "El Morrito",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 1,
    "text": "",
    "flavorText": "Chavito del barrio, listo pa'l tiro.",
    "tags": ["token"]
  },
  {
    // Artista Callejero's Last Breath understudy — deliberately blank, per
    // the card text ("a 2/2 Copy with no abilities").
    "id": "token_street_copy",
    "name": "El Doble",
    "faction": "neutral",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "",
    "flavorText": "El show sigue, aunque cambie el actor.",
    "tags": ["token"]
  },
  {
    "id": "token_morrito_grande",
    "name": "El Morrito Grande",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 3,
    "attack": 4,
    "health": 4,
    "text": "",
    "flavorText": "Ya creció el morro.",
    "tags": ["token"]
  }
];

/**
 * Builds a Morrito instance at the given stats. Used by both the tavern-phase
 * La Clica breakpoint and the in-combat death-summon hook, so the swarm is
 * one consistent unit wherever it comes from.
 */
export function makeMorrito(
  attack: number,
  health: number,
  instanceId: string,
): Card {
  const base = tokens.find(t => t.id === MORRITO_TOKEN_ID)!;
  return { ...base, attack, health, instanceId };
}
